import React, { useEffect } from 'react'
import { COLLECT_READY } from '../constants/featureFlags'
import { useNavigate, useParams } from 'react-router-dom'

/**
 * 홈 화면 바로가기(iOS 빠른 동작 / 안드로이드 앱 바로가기)가 들어오는 자리.
 *
 *   /go/record  →  /collect
 *
 * 왜 한 번 거치나 — **앱을 다시 올리지 않고 목적지를 바꾸려고**
 * ---------------------------------------------------------
 * 바로가기의 목적지는 앱 빌드에 박힌다 (안드로이드 shortcuts.xml 의
 * android:data, iOS webview_page.dart 의 _shortcutPaths). 거기에 /search 를
 * 직접 적으면, 나중에 다른 화면으로 보내고 싶을 때 스토어 심사를 다시 받아야
 * 한다.
 *
 * 그래서 앱에는 **뜻만** 적어 두고(= record), 그 뜻이 어느 화면인지는 여기서
 * 정한다. 아래 표만 고쳐 웹을 배포하면 끝이다.
 *
 * 모르는 열쇠가 오면 홈으로 보낸다. 옛 앱이 새 열쇠를 모르거나 그 반대일 때
 * 빈 화면을 보여주는 것보다 낫다.
 *
 * replace 로 넘기는 이유 — 지나가는 자리다. 히스토리에 남기면 뒤로가기가
 * 여기로 돌아와 다시 넘기고, 사용자는 뒤로 나갈 수 없게 된다.
 */
const DESTINATIONS: Record<string, string> = {
  /*
   * '이번 주 뭐 먹었어?'
   *
   * 가려던 곳은 /collect(기록할 사진)다. 그 화면이 아직 안 열렸으면
   * 길 없는 곳으로 보내게 되므로, 열릴 때까지는 검색으로 보낸다.
   * COLLECT_READY 하나만 켜면 세 군데가 같이 열린다.
   */
  record: COLLECT_READY ? '/collect' : '/search',
}

const FALLBACK = '/main-home'

const Go: React.FC = () => {
  const navigate = useNavigate()
  const { key } = useParams<{ key: string }>()

  useEffect(() => {
    const to = (key && DESTINATIONS[key]) || FALLBACK
    navigate(to, { replace: true })
  }, [key, navigate])

  // 한 칸 깜빡이고 사라질 화면이라 아무것도 그리지 않는다.
  return null
}

export default Go
